import { render } from "./NewcomersPolite.vue?vue&type=template&id=b3e3cc88&scoped=true"
import script from "./NewcomersPolite.vue?vue&type=script&lang=js"
export * from "./NewcomersPolite.vue?vue&type=script&lang=js"

import "./NewcomersPolite.vue?vue&type=style&index=0&id=b3e3cc88&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e3cc88"]])

export default __exports__